import { useState } from "react";

export const useInstructionsState = () => {
  const [expandedInstructions, setExpandedInstructions] = useState<Set<string>>(new Set());

  const alwaysExpandQueryParam = new URLSearchParams(window.location.search).get("expanded");
  const shouldAlwaysExpand = alwaysExpandQueryParam === "true" || alwaysExpandQueryParam === "1";

  const toggleInstructions = (vendorId: string) => {
    setExpandedInstructions((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(vendorId)) {
        newSet.delete(vendorId);
      } else {
        newSet.add(vendorId);
      }
      return newSet;
    });
  };

  const isExpanded = (vendorId: string) => expandedInstructions.has(vendorId) || shouldAlwaysExpand;

  return {
    toggleInstructions,
    isExpanded,
  };
};
